
























import {Component, Vue, Prop} from 'vue-property-decorator';
import MyForm from '../MyForm';
import axios from 'axios'
// import VueInputAutowidth from 'vue-input-autowidth';

@Component
export default class List extends Vue {
  @Prop() listItem!: {[key: string]: any}
  @Prop() todoId!: number
  $store: any

  private list = this.listItem

  private editing = false;

  private form = new MyForm({
      body: this.list.body,
      isCompleted: this.list.isCompleted
      
  })

  updateList(){
      axios.patch(`/api/todo-lists/${this.todoId}/${this.list.id}`, this.form)
      .then(({data}) => {
          this.list = data
          this.$emit('listUpdated')
      })
      this.editing = false;
  }

  deleteList(){
      const confirmed: boolean = confirm('Hey Are you sure about this deletion') 
      if(confirmed){
          
          axios.delete(`/api/todo-lists/${this.todoId}/${this.list.id}`)
          .then(({data}) => {
              this.$emit('listDeleted')
          }).catch(error => {
              this.form.error = error.response.data.errors
          })
      }
  }

  get mark(): string{
      return this.list.isCompleted ? 'check' : 'times';
  }

  get color(): string {
      return this.list.isCompleted ? "text-green-700  ml-2": "text-red-700 ml-3"   
  }


  get editingEnabled():  boolean {
      return  this.$store.state.todoList.editingEnabled
  }
  
  

 }
